import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Formik } from 'formik';
import Grid from '../../components/Grid';
import Image from "../../components/Image";
import Link from "../../components/Link";
import Textarea from "../../components/FormikForm/TextArea";
import Submit from "../../components/FormikForm/Submit";
import { Card, Title, Subtitle, Text } from './styles';
import { initialValues, schema } from '../../constants/forms/newsletter/unsubscribe';
import { unsubscribeNewsletter, resetUnsubscribeNewsletter } from '../../store/actions/newsletter';
import { ConnectedFocusError } from '../../components/ConnectedFocusError';
import Snackbar from '../../components/Snackbar';
import { getUrlParamByName } from '../../helpers/get-url-param';
import { useTheme } from 'styled-components';
import checkIcon from '../../assets/icons/check_circled.svg';
import Icon from '../../components/Icon';

interface ComponentProps {
  unsubscribeNewsletterInformation: any;
  unsubscribeNewsletterStates: {
    loading: boolean;
    success: boolean;
    error: boolean;
  };
}

const NewsletterUnsubscribe: React.FC<ComponentProps> = ({
  unsubscribeNewsletterInformation,
  unsubscribeNewsletterStates,
}) => {
  const theme = useTheme() as { logo: { small: string, big: string } };
  const dispatch = useDispatch();
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [countdown, setCountdown] = useState(5);

  const onSubmit = async ({ values, actions }) => {
    try {
      const payload = {
        email: values.email,
        options: {
          reason: values.reason,
          source: 'klouser-app',
        }
      }
      dispatch(unsubscribeNewsletter(values));
    } catch (error) {
      console.error('Error during unsubscribe:', error);
    }
  };

  const email = getUrlParamByName('email');

  useEffect(() => {
    if (unsubscribeNewsletterStates.success) {
      setShowConfirmation(true);
      // Iniciar countdown
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            window.location.href = '/subscriber/signin';
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [unsubscribeNewsletterStates.success]);

  // Si se muestra la confirmación, renderizar la pantalla de éxito
  if (showConfirmation) {
    return (
      <Grid.Container style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}>
        <Grid.Row>
          <Grid.Col>
            <Card>
              <Image
                src={theme?.logo?.big}
                style={{ display: 'block', margin: '0 auto' }}
                width="128px"
                height="auto"
                className="logo-desktop"
                alt="Klouser"
                lazy
              />

              <div style={{ height: 24 }} />

              <div style={{ textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                  <Icon icon={checkIcon} size="64px" color={"#12B47A"} />
                </div>
                <div style={{ height: 22 }} />
                <Title style={{ textAlign: 'center' }}>
                  ¡Te has desuscrito correctamente!
                </Title>
                <div style={{ height: 16 }} />
                <Text style={{ textAlign: 'center' }}>
                  Ya no recibirás más correos de nuestra newsletter.
                  {/* Si cambias de opinión, puedes volver a suscribirte desde tu cuenta. */}
                </Text>
                <div style={{ height: 22 }} />
                <Link
                  href="/subscriber/signin"
                  options={{
                    type: 'filled',
                    size: 'lg',
                    skin: 'purple'
                  }}
                >
                  Ir a mi cuenta
                </Link>
                <div style={{ height: 22 }} />
                <Text style={{
                  textAlign: 'center',
                  fontSize: '14px',
                  color: '#666',
                  margin: 0
                }}>
                  Toca "Ir a mi cuenta" o aguarda ({countdown} seg.)<br />
                  y serás redirigido automáticamente
                </Text>
              </div>
            </Card>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    );
  }

  return (
    <Grid.Container style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
    }}>
      <Grid.Row>
        <Grid.Col>
          <Card>
            <Image
              src={theme?.logo?.big}
              style={{ display: 'block', margin: '0 auto' }}
              width="128px"
              height="auto"
              className="logo-desktop"
              alt="Klouser"
              lazy
            />

            <div style={{ height: 24 }} />

            <Title>¿Estás pensando en dejar de recibir nuestros correos?</Title>

            <div style={{ height: 24 }} />

            <Text>
              Si tienes un debito automatico esta acción no implica cancelarlo. Al salirte del listado de correos dejarás de recibir:
            </Text>

            <div style={{ height: 16 }} />

            <ul style={{ margin: 0 }}>
              <li><Text>Novedades importantes sobre tu comunidad</Text></li>
              <li><Text>Actividades, eventos y beneficios exclusivos</Text></li>
              <li><Text>Recomendaciones personalizadas según tus intereses</Text></li>
            </ul>

            <div style={{ height: 16 }} />

            <Text>Si más adelante querés volver a recibirlos, podés reactivarlos fácilmente.</Text>

            <div style={{ height: 24 }} />

            <Formik
              initialValues={{
                ...initialValues,
                email,
              }}
              onSubmit={(values, actions) => {
                if (onSubmit) onSubmit({ values, actions });
              }}
              validateOnChange={false}
              validateOnBlur={formSubmmited}
              validationSchema={schema}
              enableReinitialize
            >
              {({ handleSubmit, errors, values, touched, handleBlur, handleChange, ...rest }) => {
                console.log({ errors, values })

                return (
                  <form
                    className="theme-form"
                    onSubmit={(event) => {
                      setFormSubmmited(true);
                      handleSubmit(event);
                    }}
                    id="newsletter-unsubscribe-form"
                  >
                    <ConnectedFocusError />

                    <Textarea
                      name="reason"
                      error={errors["reason"]}
                      touched={touched["reason"]}
                      value={values["reason"]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Motivo de tu decisión"
                      options={{
                        label: "¿Por qué te gustaría dejar de recibir nuestros correos?",
                        marginBottom: 0,
                        minHeight: 60,
                      }}
                    />

                    <div style={{ height: 24 }} />

                    <div style={{ display: 'flex', gap: 16 }}>
                      <Link
                        href='/subscriber/signin'
                        disabled={unsubscribeNewsletterStates.loading}
                        options={{
                          skin: "purple",
                          size: "lg",
                          type: "outline",
                        }}
                      >
                        Ir a mi cuenta
                      </Link>

                      <Submit
                        isSubmmiting={unsubscribeNewsletterStates.loading}
                        options={{
                          type: "filled",
                          size: "lg",
                          skin: "purple",
                        }}
                        form="newsletter-unsubscribe-form"
                      >
                        {unsubscribeNewsletterStates.loading ? 'Procesando...' : 'No recibir más correos'}
                      </Submit>
                    </div>
                  </form>
                );
              }}
            </Formik>
          </Card>

          <Snackbar
            visible={unsubscribeNewsletterStates.error}
            options={{
              time: 2000,
              type: "error",
            }}
          >
            Error al procesar tu solicitud.
          </Snackbar>
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
  );
};

const state = ({ newsletterStore }) => {
  const { data: unsubscribeNewsletterInformation, states: unsubscribeNewsletterStates } = newsletterStore?.unsubscribe || { data: null, states: { loading: false, success: false, error: false } };

  return {
    unsubscribeNewsletterInformation,
    unsubscribeNewsletterStates,
  };
};

export default connect(state)(NewsletterUnsubscribe); 